import { message, Row, Col, Upload, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ButtonItem,
    ErrorItem,
    SelectItem,
    NotificacionPolizas,
    MensajeError,
} from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;


class XmlPrevioCuentasPorCobrar extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasConceptosIETU: null,
        objetoConceptosIETU: null,
        todasBancos: [],
        todasClientes: [],
        objetoBancos: [],
        todosClientes: [],
        archivoXml: null
    };

    async componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.setState({ loading: true });
            await axios
                .post(
                    "bancos/selectBancos",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.status === 404) {
                    } else {
                        this.setState({ todasBancos: res.data });
                        this.setState({
                            objetoBancos: res.data.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.nombre + " - " + value.banco}
                                    </Option>
                                );
                            }),
                        });
                    }
                });
            await axios
                .post(
                    "cajaefectivo/selectCajaEfectivo",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.status === 404) {
                    } else {
                        this.setState({ todasBancos: this.state.todasBancos && this.state.todasBancos?.length > 0 ? [...this.state.todasBancos, ...res.data] : res.data });
                        this.setState({
                            objetoBancos: this.state.objetoBancos && this.state.objetoBancos?.length > 0 ? [...this.state.objetoBancos, ...res.data.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                                    </Option>
                                );
                            })] : res.data.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                                    </Option>
                                );
                            }),
                        });
                    }
                });
            await axios
                .post(
                    "clientes/selectClientes",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.status === 404) {
                    } else {
                        this.setState({
                            todasClientes: res.data.clientes,
                        });
                        this.setState({
                            objetoClientes: res.data.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.stringBuscar}
                                    </Option>
                                );
                            }),
                        });
                    }
                });
            this.setState({ loading: false });
        }
    }

    cerrarXmlPrevioCuentasPorCobrar(codigo) {
        this.props.cerrarXmlPrevioCuentasPorCobrar(codigo);
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        let fd = new FormData();
        fd.append("empresaId", this.props.empresaId);
        for (var key in values) {
            if (values[key] === undefined || values[key] === "") {
            } else {
                if (values[key] !== null) {
                    fd.append(key, values[key]);
                }
            }
        }
        fd.append("xml", this.state.archivoXml);
        axios
            .post("cuentasporcobrar/agregarXmlPrevioCuentasPorCobrar", fd, {
                headers: {
                    ...this.props.headersToken,
                },
            })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado el pago correctamente");
                    this.formRef.current.resetFields();
                    this.setState({ archivoXml: null });
                    NotificacionPolizas(res.data.polizasId)
                    this.cerrarXmlPrevioCuentasPorCobrar()
                } else if (res.data.success === 1) {
                    // Aquí NO se lee `errorTimbrado`: este endpoint no timbra nada. El
                    // CFDI ya existe y viene en el XML que se sube; lo que hace es
                    // registrar el pago contra él. Los motivos que manda el servidor son
                    // sus propias validaciones, y ya están bien escritos.
                    //
                    // Va al overlay y no a una notificación porque ésta se cerraba sola a
                    // los 4.5 s, y un rechazo al registrar un pago suele ser largo.
                    MensajeError({
                        message: "No se ha podido registrar el pago",
                        description: res.data.message,
                    });
                } else {
                    message.error(res.data.message || "Hubo un error al registrar el pago");
                }
            });
    }

    cargarXmlPrevio(e) {
        this.setState({ loading: true });
        if (e.file.type === "text/xml") {
            this.setState({ archivoXml: e.file, loading: false });
        } else {
            message.error("El archivo debe ser un archivo de xml");
            this.setState({ loading: false });
        }
    }

    render() {
        return (
            <ModalItem
                title="Xml Previo Cuentas Por Cobrar"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarXmlPrevioCuentasPorCobrar.bind(this)}
                paddingTop
                width="50%"
            >
                <Form
                    ref={this.formRef}
                    name="xmlPrevioCuentasPorCobrar"
                    layout
                    bottom={
                        <ButtonItem
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                        >
                            Agregar
                        </ButtonItem>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={24}>
                            <FormItem
                                label="Banco"
                                name="bancoId"
                                margin
                                required
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                            >
                                <SelectItem placeholder="Banco">
                                    {this.state.objetoBancos}
                                </SelectItem>
                            </FormItem>
                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                <FormItem
                                    name="xmlPrevio"
                                    margin
                                    required
                                >
                                    <Upload
                                        showUploadList={{
                                            showRemoveIcon: false,
                                            showPreviewIcon: false,
                                        }}
                                        fileList={this.state.archivoXml ? [this.state.archivoXml] : []}
                                        customRequest={(e) => this.cargarXmlPrevio(e)}
                                        accept=".xml"
                                    >
                                        <ButtonItem type="primary" blanco icon={<UploadOutlined />}>Xml previo</ButtonItem>
                                    </Upload>

                                </FormItem>
                            </div>

                        </Col>
                    </Row>
                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        empresaRfc: state.empresa.rfc,
    };
};

export default connect(mapStateToProps)(XmlPrevioCuentasPorCobrar);
